import React from 'react';
import { Label } from './ui/label';
import { Input } from './ui/input';
import { Checkbox } from './ui/checkbox';

interface EmailInputProps {
  email: string;
  onEmailChange: (email: string) => void;
  onEmailBlur?: () => void;
  consent: boolean;
  onConsentChange: (consent: boolean) => void;
  emailError?: string;
  required?: boolean;
  className?: string;
}

export default function EmailInput({
  email,
  onEmailChange,
  onEmailBlur,
  consent,
  onConsentChange,
  emailError,
  required = true,
  className = '',
}: EmailInputProps) {
  return (
    <div className={`space-y-4 ${className}`}>
      <div className="space-y-2">
        <Label htmlFor="email" className="text-sm font-medium">
          Email Address {required && <span className="text-destructive">*</span>}
        </Label>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          onBlur={onEmailBlur}
          placeholder="your@email.com"
          className={emailError ? 'border-destructive' : ''}
          required={required}
          aria-describedby={emailError ? 'email-error' : undefined}
        />
        {emailError && (
          <p id="email-error" className="text-xs text-destructive">
            {emailError}
          </p>
        )}
      </div>

      <div className="flex items-start space-x-2">
        <Checkbox
          id="consent"
          checked={consent}
          onCheckedChange={onConsentChange}
          className="mt-0.5"
          aria-describedby="consent-description"
        />
        <Label
          htmlFor="consent"
          className="text-xs text-muted-foreground leading-relaxed cursor-pointer"
        >
          <span id="consent-description">
            You may email me about this request and related domain opportunities.
          </span>
        </Label>
      </div>
    </div>
  );
}
